module.exports = __webpack_public_path__ + "img/tp-drag-indicator.972a3052.svg";